import React, { useEffect, useState } from "react";
import { ModalBody, Modal, Row, Col, Table } from "reactstrap";
import { Alert, Snackbar } from "@mui/material";
import AddNewUser from "./_addNewUser";
import MyDataGrid from "./MyDataGrid";
import getUserRole from "../../helpers/jwt-token-access/userRole";

const allowedRoles = ["PowerUser", "Administrator"];

const UserConfigurationDetailsTab = ({
  addNewUserResponse,
  editUserResponse,
  usersConfig,
  accounts,
  organizations,
  licensing,
  roleAccess,
  onReActive,
  onDelete,
  onToggle,
  handleSubmit,
  hanldeResetNewUser,
}) => {
  const [disableAddUser, setDisableAddUser] = useState(false);
  const [manageUser, setManageUser] = useState({
    selectedUser: {},
    showAdduser: false,
  });
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(null);
  const [accountList, setaccountList] = useState([]);
  const [showUserSuccessStatus, setShowUserSuccessStatus] = useState(null);
  const { showAdduser, selectedUser } = manageUser;
  const userRole = getUserRole();

  const setModalIsOpenToTrue = () => {
    setModalIsOpen(true);
  };
  const setModalIsOpenToFalse = () => {
    setModalIsOpen(false);
  };

  const handleCancelClick = (val) => {
    setManageUser({ selectedUser: {}, showAdduser: val });
    hanldeResetNewUser();
  };

  const addNewUserMessage = addNewUserResponse?.addNewUserMessage;
  const editUserMessage = editUserResponse?.editUserMessage;
  useEffect(() => {
    if (addNewUserMessage || editUserMessage) {
      if (selectedUser && Object.keys(selectedUser).length > 0) {
        setShowUserSuccessStatus(editUserMessage);
      } else {
        setShowUserSuccessStatus(addNewUserMessage);
      }
      setTimeout(() => setShowUserSuccessStatus(null), 10000);
    }
  }, [addNewUserMessage, editUserMessage]);

  useEffect(() => {
    if (licensing) {
      const numUsers = licensing.numUsers;
      if (usersConfig) {
        if (usersConfig.length >= numUsers) {
          setDisableAddUser(true);
        } else {
          setDisableAddUser(false);
        }
      }
    }
  }, [licensing, usersConfig]);

  const handleEditUser = (user) => {
    setManageUser({ showAdduser: true, selectedUser: user });
  };

  const handleConfirmationClick = () => {
    if (showConfirmation && showConfirmation.action === "delete") {
      onDelete(showConfirmation);
    } else {
      onReActive({ email: showConfirmation.email });
    }
    setShowConfirmation(null);
  };

  const onAddUserClick = () => {
    setManageUser({ selectedUser: {}, showAdduser: true });
  };

  return (
    <React.Fragment>
      <Modal
        size="lg"
        backdrop="static"
        centered
        style={{ display: "flex" }}
        isOpen={modalIsOpen}
      >
        <div>
          <div style={{ textAlign: "right" }}>
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              style={{ margin: 8 }}
              onClick={setModalIsOpenToFalse}
            >
              Close
            </button>
          </div>
        </div>
        <ModalBody>
          <Table
            className="table-centered datatable dt-responsive nowrap"
            style={{
              borderCollapse: "collapse",
              borderSpacing: 0,
              width: "100%",
            }}
          >
            <thead
              style={{
                backgroundColor: "#f8fafc",
                textAlign: "left",
                color: "#64748b",
                fontSize: "0.75rem",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              <tr>
                <th className="text-center">Account Name</th>
                <th className="text-center">Account Number</th>
                <th className="text-center">Account Type</th>
              </tr>
            </thead>
            <tbody>
              {accountList.map((acct, index) =>
                !acct.accountNumber.includes("INIT00000001") ? (
                  <tr key={index}>
                    <td>{acct.accountName}</td>
                    <td>{acct.accountNumber}</td>
                    <td>{acct.accountType}</td>
                  </tr>
                ) : null
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      <div style={{ position: "absolute" }}>
        {showAdduser && (
          <AddNewUser
            accounts={accounts}
            organizations={organizations}
            usersConfig={usersConfig}
            setShowAddUsers={handleCancelClick}
            selectedUser={selectedUser}
            showAdduser={showAdduser}
            handleOnSubmit={handleSubmit}
            addNewUserResponse={addNewUserResponse}
            editUserResponse={editUserResponse}
          />
        )}
      </div>

      <Modal isOpen={showConfirmation} className="col-sm-8">
        <ModalBody>
          <div className="d-flex flex-column align-items-center">
            <h4 className="text-secondary">
              {showConfirmation && showConfirmation.action === "delete"
                ? `Are you sure, you want to delete ${showConfirmation.username} `
                : "Confirm resend activation ?"}
            </h4>
            <div className="mt-2 d-flex justify-content-end">
              <button
                className="btn btn-sm btn-secondary mr-2"
                onClick={() => setShowConfirmation(null)}
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-primary ml-2"
                onClick={handleConfirmationClick}
              >
                OK
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Row>
        <Col lg={12}>
          <MyDataGrid
            usersConfig={usersConfig}
            setaccountList={setaccountList}
            setModalIsOpenToTrue={setModalIsOpenToTrue}
            handleEditUser={handleEditUser}
            roleAccess={roleAccess}
            setShowConfirmation={setShowConfirmation}
            onToggle={onToggle}
            disableAddUser={
              disableAddUser ||
              usersConfig?.length >= licensing.numUsers ||
              !allowedRoles.includes(userRole)
            }
            onAddUserClick={onAddUserClick}
          />
        </Col>
      </Row>

      <Snackbar
        open={showUserSuccessStatus !== null}
        autoHideDuration={5000}
      >
        <Alert severity="success">{showUserSuccessStatus}</Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default React.memo(UserConfigurationDetailsTab);
